import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * ** ReservHotel **
 *
 * Official: www.reservhotel.com
 *
 *  This BE is always used for booking that has flights and rooms
 *
 * Example: <a href="https://www.grandsolmartheresidences.com/" target="_blank">Grand Sol Mar The Residences</a>
 *
 * @exports bs_65
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};
  const isTemptationCancunPackage = thn.data.propertyId === 1016258;
  /**
     * @memberOf module:bs_65
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {

      const reservLangs = {
        1: 'en',
        2: 'es',
        3: 'fr',
        4: 'de',
        5: 'pt',
        7: 'it',
        9: 'nl',
        10: 'pl',
      };

      // El Cid Resorts
      if (thn.data.accountUserId === 1032597 && window.location.hostname === 'www.elcidresorts.com.mx') {
        resolve('es');
        return;
      }

      // Hotel Santa Fe MX
      if (window.location.hostname.match(/hotelsantafe/)) {
        if (window.location.pathname.match(/^\/$/)) {
          resolve('es');
          return;
        }
      }

      const langNum = thn.parseUrlParameter('lang') || document.selfy?.lang?.value;
      const lang = langNum && reservLangs[langNum];
      if (lang && ctx.langs.test(lang)) {
        resolve(lang);
        return;
      }

      if (!window.changeLang) {
        reject('no_language');
      }

      resolve('en');
    });
  };

  /**
     * @memberOf module:bs_65
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {

    /* https://www.reservhotel.com/miami-united-states/test-hotel/booking-engine/ibe5_rooms.main?hotel=10215&aDate=16-JUN-24&dDate=19-JUN-24&lang=1&source=&IP=&S=162252685
    &currency=&room=&rate=&allow_cash=N&agent=&show_ta_comm=&abtest=&agent_fee=&usr=&showHotel=&sub_source=&view_type=&usr_country=ES&chat=&PCC=&AirportDep=&r=https%3A%2F%
    2Fwww.reservhotel.com%2Fmiami-united-states%2Ftest-hotel%2Fbooking-engine%2Fibe5_rooms.main%3Fhotel%3D10215_aDate%3D13-MAY-24_dD&rategroup=&hide_agent_info=&callc_num=
    &adults=2&child=0&rooms=1&AFF=&PC=&airline=&fareclass=E&stops=
    */
    const url = new URL(ctx.baseUrl);
    const validUrl = url.hostname.match(/reservhotel/);

    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }

    // Export into ctx.newUrl
    ctx.newUrl = url.toString();

    return ctx;
  };

  /**
     * @memberOf module:bs_65
     * @see {@link onStateChange}
     *
     * @param {object} ctx - The context object.
     */
  engine.onStateChange = function onStateChange(ctx) {
    setTimeout(thn.pageCheck, 400);
  };

  /**
     * @memberOf module:bs_65
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceObserveDom = function priceObserveDom(ctx) {

    const $ = window.jQuery;

    if (!$) {
      this.logger.warn('Unable to execute, missing jQuery');
      return;
    }

    // Two versions of this BS, 4 is the "classic", 5 is the "new"
    const version = window.location.pathname.match(/ibe5/) ? 5 : 4;

    if (version === 4) {

      let _selectRoom;
      let pricesAreLoaded = document.querySelectorAll('#loader .we-are-looking').length === 0;
      const loader = document.querySelector('#loader');

      const priceObserverV4 = function () {

        ctx.widget.logger.debug('*************** DOM Changed **************');

        // this change comes from room selection
        const summary = document.querySelector('.travel-summary-stuff');

        if (pricesAreLoaded && thn.isVisible(summary)) {
          ctx.widget.minimize();
          // this change comes from prices being loaded for the first time
        } else if (!pricesAreLoaded) {
          pricesAreLoaded = document.querySelectorAll('#loader .we-are-looking').length === 0;
          ctx.widget.remove().setData();
          if (ctx.widget.isSet()) {
            ctx.widget.show();

            // should happen only once
            if (window.selectRoom) {
              // hijack load results function
              _selectRoom = window.selectRoom;
              window.selectRoom = function () {
                // do thn stuff
                ctx.widget.minimize();
                // call original
                _selectRoom.apply(this, arguments);
              };
            }
          }
        }
      };

      thn.observeDom(loader, priceObserverV4);

      thn.pageUnload(function () {
        thn.stopObserveDom(loader, priceObserverV4);
      });

    } else if (version === 5) {

      const container = document.querySelector('body');

      if (container) {
        let refreshPrice = thn.debounce(() => {
          const isLoading = thn.isVisible(document.querySelector('#loadersec'));
          if (!isLoading) {
            ctx.widget.refresh();
          }
        }, 600);

        thn.observeDom(container, refreshPrice, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributesFilter: ['class', 'style'],
        });

        thn.pageUnload(() => {
          refreshPrice.cancel();
          thn.stopObserveDom(container, refreshPrice);
          refreshPrice = null;
        });
      }
    }
  };

  /**
     *
     * Impossible to implement **noRooms** because it is in Calendar Page.
     *
     * @memberOf module:bs_65
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};

    // noRooms: seems it redirects to calendar

    // Dates
    const dateBeginRaw = thn.parseUrlParameter('aDate') || document.querySelector('#aDate')?.value;
    const dateBeginUrl = thn.parseUrlParameter('fromDate');
    const dateBegin = dateBeginRaw ? translateDate(dateBeginRaw, 'en') : dateBeginUrl;

    const dateEndRaw = thn.parseUrlParameter('dDate') || document.querySelector('#dDate')?.value;
    const dateEndUrl = thn.parseUrlParameter('toDate');
    const dateEnd = dateEndRaw ? translateDate(dateEndRaw, 'en') : dateEndUrl;

    let nights;

    if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin;
      widgetData.dateEnd = dateEnd;
      nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
    }

    // Rooms
    const numRooms = thn.parseNumber(thn.parseUrlParameter('rooms')) || thn.parseNumber(document.querySelector('#rooms')?.value) || 1;

    // Guests
    widgetData.adults = thn.parseNumber(thn.parseUrlParameter('adults')) || thn.parseNumber(document.querySelector('#hotel_adults')?.value) || thn.parseNumber(thn.parseUrlParameter('guests')) || 2;
    widgetData.children = thn.parseNumber(thn.parseUrlParameter('children')) || thn.parseNumber(thn.parseUrlParameter('child')) || thn.parseNumber(document.querySelector('#hotel_children')?.value) || 0;
    // add infants to children
    widgetData.children += thn.parseNumber(thn.parseUrlParameter('infants')) || thn.parseNumber(thn.parseUrlParameter('infant')) || thn.parseNumber(document.querySelector('#hotel_infants')?.value) || 0;

    widgetData.guests = widgetData.adults + widgetData.children;

    // Price
    const priceSelector = '.hotel-list .price, b.price-c.money.custom-price, .room-descriptions .card-text';
    const priceEls = document.querySelectorAll(priceSelector);
    const prices = [...priceEls].map((priceEl) => thn.parseNumber(priceEl?.innerText)).filter(Boolean);

    // Currency
    const shouldReadIframeParamCurrency = [1037538].includes(thn.data.accountUserId) || isTemptationCancunPackage;
    const currencyIframeSrc = document.querySelector('head > iframe')?.src;
    // If the currency is in the iframe param, we should read it from there, otherwise we should read it from the page.
    if (shouldReadIframeParamCurrency && currencyIframeSrc) {
      const currencyIframeParam = new URLSearchParams(currencyIframeSrc);
      widgetData.currency = thn.parseUrlParameter('currency') || Object.fromEntries(currencyIframeParam)?.hcu || 'MXN';
    } else {
      widgetData.currency = thn.parseCurrency(document.querySelector('#currency')?.value) || thn.parseCurrency(thn.parseUrlParameter('currency')) || thn.parseCurrency(document.querySelector(priceSelector)?.textContent) || 'USD';
    }

    if (!thn.empty(prices) && nights && !thn.isVisible(document.querySelector('#loadersec'))) {
      widgetData.price = Math.min(...prices);
      widgetData.rooms = numRooms;
    } else {
      return null;
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_65
     * @this thn.widgets.package
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.packageObserveDom = engine.priceObserveDom;

  /**
     *
     * Impossible to implement **noRooms** because it is in Calendar Page.
     *
     * @memberOf module:bs_65
     * @this thn.widgets.package
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.packageParseData = function packageParseData(ctx) {

    const widgetData = engine.priceParseData(ctx);
    const linkHref = document.querySelector('.breadcrumb-item.step-finish a[href]')?.href;

    // Flights
    widgetData.flightOrigin = thn.parseUrlParameter('airport')
            || document.querySelector('#airport')?.value
            || linkHref?.match(/airport=([^&]+)/)?.[1];

    widgetData.flightDestination = thn.parseUrlParameter('airportTo')
            || document.querySelector('#airportTo')?.value
            || (linkHref?.match(/airportTo=([^&]+)/)?.[1]) || document.querySelector("input[name='airportTo']")?.value;

    // Price is per_person/per_package
    if (widgetData.price && widgetData.guests) {
      widgetData.price *= widgetData.guests;
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_65
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};
    const $ = window.jQuery;

    widgetData.bookingId = thn.parseUrlParameter('conf');
    widgetData.currency = thn.parseUrlParameter('currency');

    let dateBegin,
      dateEnd,
      price,
      bookingId;

    if ($) {

      price = $('.payment-breakdown-wrap .prices-box-inner div:last-child span:last-child').text();
      dateBegin = $('.hotel-info-wrap .col-third > div div:nth-child(2)').text();
      dateEnd = $('.hotel-info-wrap .col-third > div div:nth-child(3)').text();
      bookingId = $('.c-code').text();

    } else if (document.querySelector) {

      price = document.querySelector('.payment-breakdown-wrap .prices-box-inner div:last-child span:last-child').textContent;
      dateBegin = document.querySelector('.hotel-info-wrap .col-third > div div:nth-child(2)').textContent;
      dateEnd = document.querySelector('.hotel-info-wrap .col-third > div div:nth-child(3)').textContent;
      bookingId = document.querySelector('.c-code').textContent;
    }

    if (dateBegin) {
      dateBegin = dateBegin.split(':');
      if (dateBegin.length) {
        // an error in the french language forces to check the last part of the split
        widgetData.dateBegin = translateDate(dateBegin[dateBegin.length - 1].trim(), thn.data.language);
      }
    }

    if (dateEnd) {
      dateEnd = dateEnd.split(':');
      if (dateEnd.length) {
        // an error in the french language forces to check the last part of the split
        widgetData.dateEnd = translateDate(dateEnd[dateEnd.length - 1].trim(), thn.data.language);
      }
    }

    // Fallback for version 5
    if ($ && (thn.empty(widgetData.dateBegin) || thn.empty(widgetData.dateEnd))) {
      const $dates = $('.fa-bell-hotel + span');
      if ($dates.length === 2) {
        widgetData.dateBegin = translateDate($dates.eq(0).text().trim(), thn.data.language || 'en');
        widgetData.dateEnd = translateDate($dates.eq(1).text().trim(), thn.data.language || 'en');
      }
    }

    if (price) {
      widgetData.price = thn.parseNumber(price);
    }

    if (!widgetData.currency && price) {
      widgetData.currency = thn.getCurrencyCode((price.match(/[^\d\s,.]+/) || [])[0]);
    }

    if (!widgetData.bookingId && bookingId) {
      widgetData.bookingId = bookingId.trim();
    }

    // Save promocode
    const promocode = thn.dataLayerHelper.get('promo_code');
    if (promocode) {
      widgetData.promocode = promocode;
    }

    // Fallback for version 5
    if ($ && thn.empty(widgetData.currency)) {
      const currencyStyleMatch = $('style:eq(0)').text().match(/.money::?after[^{]*{\s*content:\s*["']([^"']+)/);
      if (currencyStyleMatch && currencyStyleMatch.length === 2) {
        widgetData.currency = thn.getCurrencyCode(currencyStyleMatch[1]);
      }
    }

    return widgetData;
  };

  /**
    * @memberOf module:bs_65
    * @this thn.widgets.price
    * @see {@link Price#getPromocode}
    *
    * @param {object} ctx - The context object.
    */
  engine.getPromocode = function getPromocode(ctx) {
    const promoCode = thn.parseUrlParameter('PC');
    ctx.promocode = promoCode || '';
    return ctx.promocode;
  };

  return engine;

}

export { factory };
